"use strict";

const idlUtils = require("../generated/utils");

exports.implementation = class MimeTypeArray {
  get length() {
    return 0;
  }

  item() {
    return null;
  }

  namedItem() {
    return null;
  }

  get [idlUtils.supportedPropertyIndices]() {
    return [];
  }
};
